// src/utils/avatar.js

import React from 'react';

export const templates = [
  {
    name: "Sunset Forest",
    bg: "#ebdcb9",
    border: "#1a130b",
    leftHead: "#ff8800",
    rightHeadBg: "#fbaa1d",
    rightHeadAccent: "#be1e2d",
    leftShoulder: "#1c2b36",
    rightShoulderBg: "#f39200",
    stripes: ["#f05a28", "#e11b22", "#a30f15"]
  },
  {
    name: "Ocean Breeze",
    bg: "#d5e5e8",
    border: "#0b151a",
    leftHead: "#00A896",
    rightHeadBg: "#028090",
    rightHeadAccent: "#05668D",
    leftShoulder: "#2D3142",
    rightShoulderBg: "#028090",
    stripes: ["#05668D", "#02c39a", "#00a896"]
  },
  {
    name: "Cyber Purple",
    bg: "#ebd9fc",
    border: "#18062b",
    leftHead: "#7B2CBF",
    rightHeadBg: "#9D4EDD",
    rightHeadAccent: "#E0AAFF",
    leftShoulder: "#10002B",
    rightShoulderBg: "#5A189A",
    stripes: ["#9D4EDD", "#FF006E", "#7B2CBF"]
  },
  {
    name: "Warm Terracotta",
    bg: "#ebd9d0",
    border: "#241813",
    leftHead: "#D66853",
    rightHeadBg: "#DF9A82",
    rightHeadAccent: "#3D5A50",
    leftShoulder: "#2E2522",
    rightShoulderBg: "#D66853",
    stripes: ["#DF9A82", "#829C8B", "#587B6A"]
  },
  {
    name: "Emerald Gold",
    bg: "#d8eade",
    border: "#0e1a12",
    leftHead: "#1B4332",
    rightHeadBg: "#2D6A4F",
    rightHeadAccent: "#D4AF37",
    leftShoulder: "#081C15",
    rightShoulderBg: "#40916C",
    stripes: ["#52B788", "#95D5B2", "#D4AF37"]
  }
];

export const renderGeometricAvatar = (templateIndex, size = 100, idSuffix = '') => {
  const index = Math.max(0, Math.min(templates.length - 1, parseInt(templateIndex, 10) || 0));
  const t = templates[index];
  const uniqueId = `avatar-${index}${idSuffix}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      style={{ display: 'block', borderRadius: '50%', flexShrink: 0 }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Main avatar outer circle clip */}
        <clipPath id={`main-clip-${uniqueId}`}>
          <circle cx="50" cy="50" r="46.5" />
        </clipPath>
        
        {/* Right shoulder clip */}
        <clipPath id={`shoulder-clip-${uniqueId}`}>
          <path d="M 50 56 A 28 28 0 0 1 82 84 L 82 98 L 50 98 Z" />
        </clipPath>
      </defs>

      {/* Background Circle */}
      <circle cx="50" cy="50" r="47" fill={t.bg} stroke={t.border} strokeWidth="3" />

      {/* Main Clipped Content */}
      <g clipPath={`url(#main-clip-${uniqueId})`}>
        {/* Left Shoulder (Curved Quadrant) */}
        <path d="M 50 56 A 28 28 0 0 0 18 84 L 18 98 L 50 98 Z" fill={t.leftShoulder} />

        {/* Right Shoulder (Clipped layered stripes) */}
        <g clipPath={`url(#shoulder-clip-${uniqueId})`}>
          <rect x="50" y="56" width="40" height="42" fill={t.rightShoulderBg} />
          <rect x="50" y="72" width="40" height="8" fill={t.stripes[0]} />
          <rect x="50" y="80" width="40" height="8" fill={t.stripes[1]} />
          <rect x="50" y="88" width="40" height="12" fill={t.stripes[2]} />
        </g>

        {/* Left Head (Semi-circle) */}
        <path d="M 50 21 A 17 17 0 0 0 50 55 Z" fill={t.leftHead} />

        {/* Right Head (Semi-circle) */}
        <path d="M 50 21 A 17 17 0 0 1 50 55 Z" fill={t.rightHeadBg} />

        {/* Right Head Accent Overlapping Circle */}
        <circle cx="58" cy="36" r="9" fill={t.rightHeadAccent} />
      </g>
    </svg>
  );
};
